export const TAB_KEYS = {
  ALL: "ALL",
  INACTIVE: "INACTIVE",
};
export const TAB_LISTS = [
  {
    key: TAB_KEYS.ALL,
    isActive: function (currentTab) {
      return isTabActive(this.key, currentTab);
    },
    value: "USER_MANAGEMENT.TABS.ALL",
    count: function (tabsCount) {
      return tabsCount?.[this.key] || 0;
    },
  },
  {
    key: TAB_KEYS.INACTIVE,
    isActive: function (currentTab) {
      return isTabActive(this.key, currentTab);
    },
    value: "USER_MANAGEMENT.TABS.INACTIVE",
    count: function (tabsCount) {
      return tabsCount?.[this.key] || 0;
    },
  },
];

function isTabActive(tab, currentTab) {
  return tab === currentTab;
}
